export default __webpack_public_path__ + "static/media/customer.909af011.svg";